/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_SubmittingInputs */

const en_audit_submitting = /** @type {(inputs: Audit_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitting...`)
};

const es_audit_submitting = /** @type {(inputs: Audit_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando...`)
};

/**
* | output |
* | --- |
* | "Submitting..." |
*
* @param {Audit_SubmittingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_submitting = /** @type {((inputs?: Audit_SubmittingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_SubmittingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_submitting(inputs)
	return es_audit_submitting(inputs)
});